import { Link } from 'react-router-dom'
import { OPERATOR } from '../content/provenance'
import PolicyPage, { Section } from './PolicyPage'

export default function DisclaimerPage() {
  return (
    <PolicyPage title="Disclaimer" intro="Who makes Mission Design System, and what showing an agency’s theme does and does not mean.">
      <Section id="operator" heading="A design system, not a government site">
        <p>
          Mission Design System is built and operated by <a href={OPERATOR.url}>{OPERATOR.name}</a>, a private company. It
          is not an official website of the United States government, and it is not affiliated with, sponsored by or
          endorsed by any federal agency.
        </p>
        <p>
          MDS publishes styles, components, templates and guidance that agencies and their partners can use to build
          their own websites. A site built with MDS is official when an agency publishes it on its own domain, under its
          own authority.
        </p>
      </Section>
      <Section id="previews" heading="Agency themes and previews">
        <p>
          Choosing a mission shows how a site for that agency could look, with its colors, seal, logo and photographs.
          These are previews: the official banner on them carries a Preview tag, and the agency has not reviewed,
          approved or adopted the design.
        </p>
      </Section>
      <Section id="marks" heading="Agency names, seals and logos">
        <p>
          Agency names, seals, logos, insignia and photographs belong to their agencies and creators, and are credited
          where they appear and on the <Link to="/credits">Credits</Link> page. Their use here identifies the agency a
          theme is for and implies no endorsement. Federal law restricts the use of agency seals and insignia; a site
          that adopts a theme follows its agency’s rules for its own marks.
        </p>
      </Section>
      <Section id="authorization" heading="Authorization and compliance">
        <p>
          Using MDS does not make a site authorized to operate, accessible or compliant. Each agency assesses and
          authorizes its own system, including its security, privacy and accessibility, in its operating context.
        </p>
      </Section>
      <Section id="content" heading="Content and examples">
        <p>
          Names, numbers, dates and services in the examples and templates are illustrative and do not describe any
          agency’s actual programs. Use of MDS is governed by its <Link to="/license">License</Link>.
        </p>
      </Section>
    </PolicyPage>
  )
}
